import { render, staticRenderFns } from "./InsInform.vue?vue&type=template&id=916fdaca&scoped=true"
import script from "./InsInform.vue?vue&type=script&lang=ts"
export * from "./InsInform.vue?vue&type=script&lang=ts"
import style0 from "./InsInform.vue?vue&type=style&index=0&id=916fdaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916fdaca",
  null
  
)

export default component.exports